module.exports = __webpack_public_path__ + "img/c9ea766.png";